import styled, { css } from 'styled-components/macro';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 20px;

    & * {
      color: ${theme.semantic.icon.disabled};
      cursor: inherit;
      transition-duration: ${theme.tokens.animation.duration.base};
    }

    &:hover {
      color: ${theme.semantic.icon.secondaryHover};
    }
  `}
`;
